module.exports = __webpack_public_path__ + "static/debtIcon-ff45584ed913a76265f1572f8448be7f.png";